import { useForm } from 'react-hook-form';
import {
  CollateralFormDataValues,
  useCollateralFormSchemaResolver,
} from './schema';
import { useCollateralFormDefaultValues } from './defaultValues';
import { useCollateralFormContext } from './context';

export const useCollateralForm = (applicationID: string) => {
  const formSchemaResolver = useCollateralFormSchemaResolver(applicationID);
  const defaultValues = useCollateralFormDefaultValues(applicationID);
  const { formControl } = useCollateralFormContext(applicationID);

  const formMethods = useForm<CollateralFormDataValues>({
    defaultValues,
    values: defaultValues,
    resolver: formSchemaResolver,
    formControl,

    // Example of extra options we might want
    mode: 'all',
    reValidateMode: 'onChange',
    criteriaMode: 'all',
  });

  return formMethods;
};
